import { NativeSelect } from '@material-ui/core';
import CSS from 'csstype';
import React from 'react';

import { FONT_WEIGHT, fontSizing } from '~/src/dash/components/text/common';

export type MobileNativeSelectSize = 'base' | 'large';

export const mobileNativeSelectSizeStyle = (size: MobileNativeSelectSize): CSS.Properties => {
  switch (size) {
    case 'large':
      return {
        fontSize: fontSizing.large,
        padding: '0px 24px 0px 0px',
        fontWeight: FONT_WEIGHT.bold,
      };
    case 'base':
    default:
      return {
        fontSize: fontSizing.base,
        padding: '0px 16px 0px 0px',
      };
  }
};

export interface IMobileNativeSelectOption {
  value: number | string;
  label: string;
}

interface IMobileNativeSelectProps {
  defaultValue: number | string;
  handleChange: React.ChangeEventHandler<HTMLSelectElement>;
  options: IMobileNativeSelectOption[];
  size?: MobileNativeSelectSize;
  inputStyle?: CSS.Properties;
  style?: CSS.Properties;
}

export const MobileNativeSelect = ({
  defaultValue,
  options,
  handleChange,
  size = 'base',
  inputStyle = {},
  style = {},
}: IMobileNativeSelectProps) => {
  return (
    <NativeSelect
      value={defaultValue}
      fullWidth
      disableUnderline
      onChange={(e) => {
        // @ts-ignore
        handleChange(e.target.value);
      }}
      inputProps={{
        style: {
          border: 'none',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          ...mobileNativeSelectSizeStyle(size),
          ...inputStyle,
        },
      }}
      style={style}
    >
      {options.map(({ label, value }) => (
        <option value={value}>{label}</option>
      ))}
    </NativeSelect>
  );
};
